import React from 'react'
import PropTypes from 'prop-types'
import ImmutablePureComponent from 'react-immutable-pure-component'
import { connect } from 'react-redux'
import debounce from 'lodash/debounce'
import {
  expandMarketplaceListingFrontPage,
} from '../actions/marketplace_listings'
import MarketplaceListingsHorizontalCollection from '../components/marketplace/marketplace_listings_horizontal_collection'
import { marketplaceSearchReset } from '../actions/marketplace_listing_search'

class MarketplaceListingsFrontPage extends ImmutablePureComponent {

  componentDidMount() {
    this.props.onExpandMarketplaceListingFrontPage()
    this.props.onMarketplaceSearchReset()
  }

  handleLoadMore = debounce(() => {
    this.props.onExpandMarketplaceListingFrontPage()
  }, 300, { leading: true })

  render() {
    const {
      recentListingIds,
      loadedCategoryIds,
      categoryData,
      categories,
      isLoading,
      isError,
      hasMore,
    } = this.props

    if (!recentListingIds || !categoryData || !loadedCategoryIds || !categories) return null

    const data = [
      {
        title: 'Latest Listings',
        ids: recentListingIds,
      },
      ...loadedCategoryIds.map((id) => {
        const category = categories.find((c) => `${c.get('id')}` === `${id}`)
        const ids = categoryData.get(`${id}`)
        return {
          title: !!category ? category.get('name') : '',
          to: !!category ? `/marketplace/listings/${category.get('slug')}` : '',
          ids: ids || [],
        }
      }).toList().toJS(),
    ]

    return (
      <MarketplaceListingsHorizontalCollection
        data={data}
        isLoading={isLoading}
        isError={isError}
        hasMore={hasMore}
        onLoadMore={this.handleLoadMore}
      />
    )
  }

}

const mapDispatchToProps = (dispatch) => ({
  onExpandMarketplaceListingFrontPage(params) {
    dispatch(expandMarketplaceListingFrontPage(params))
  },
  onMarketplaceSearchReset() {
    dispatch(marketplaceSearchReset())
  },
})

const mapStateToProps = (state) => ({
  recentListingIds: state.getIn(['marketplace_listings_lists', 'frontpage', 'items', 'recent']),
  categoryData: state.getIn(['marketplace_listings_lists', 'frontpage', 'items', 'categories']),
  categories: state.getIn(['marketplace_listing_categories', 'items']),
  hasMore: state.getIn(['marketplace_listings_lists', 'frontpage', 'hasMore']),
  isLoading: state.getIn(['marketplace_listings_lists',  'frontpage', 'isLoading']),
  isError: state.getIn(['marketplace_listings_lists', 'frontpage', 'isError']),
  loadedCategoryIds: state.getIn(['marketplace_listings_lists', 'frontpage', 'loadedCategoryIds']),
})

MarketplaceListingsFrontPage.propTypes = {
  onExpandMarketplaceListingFrontPage: PropTypes.func,
  hasMore: PropTypes.bool,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(MarketplaceListingsFrontPage)
